import React, { useState, useEffect } from 'react';
import { obtenerUrlArchivo } from '../servicios/api';

const ModalEditarProducto = ({ product, onClose, onSave }) => {
  const [editedProduct, setEditedProduct] = useState(product);

  useEffect(() => {
    setEditedProduct(product);
  }, [product]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setEditedProduct({ ...editedProduct, [name]: files[0] });
    } else {
      setEditedProduct({ ...editedProduct, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(editedProduct);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full p-6">
        <h3 className="text-lg font-semibold text-gray-100 mb-4">Editar Producto</h3>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Nombre</label>
              <input
                type="text"
                name="nombre"
                value={editedProduct.nombre || ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Modelo</label>
              <input
                type="text"
                name="modelo"
                value={editedProduct.modelo || ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Marca</label>
              <input
                type="text"
                name="marca"
                value={editedProduct.marca || ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Categoría</label>
              <input
                type="text"
                name="categoria"
                value={editedProduct.categoria || ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Stock Actual</label>
              <input
                type="number"
                name="stock_actual"
                value={editedProduct.stock_actual || 0}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Stock Mínimo</label>
              <input
                type="number"
                name="stock_minimo"
                value={editedProduct.stock_minimo || 0}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
              <p className="mt-1 text-xs text-gray-500">Si el stock actual llega a este nivel o baja de él, el producto aparecerá en Bajo Stock.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Precio de venta</label>
              <input
                type="number"
                name="precio"
                step="0.01"
                value={editedProduct.precio || 0.00}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Precio de compra</label>
              <input
                type="number"
                name="precio_compra"
                min="0"
                step="0.01"
                value={editedProduct.precio_compra ?? ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-300 mb-1">Ubicación</label>
              <input
                type="text"
                name="ubicacion"
                value={editedProduct.ubicacion || ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-300 mb-1">Imagen del Producto</label>
              <input
                type="file"
                name="imagen_producto"
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-700 rounded-lg bg-gray-900 text-gray-300 focus:ring-blue-500 focus:border-blue-500"
              />
              {editedProduct.imagen_url && typeof editedProduct.imagen_producto !== 'object' && (
                <p className="text-gray-400 text-sm mt-1">Imagen actual: <a href={obtenerUrlArchivo(editedProduct.imagen_url)} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Ver imagen</a></p>
              )}
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-300 border border-gray-700 rounded-lg hover:bg-gray-700"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-400"
            >
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalEditarProducto;